
import { 
	useEffect, 
	useState 
}						from "react";
import { 
	Card, 
	Row, 
	Col, 
	InputGroup, 
	Form, 
	Button
}						from "react-bootstrap";
import ProgressBar		from 'react-bootstrap/ProgressBar';
import { 
	X, 
	ClockCounterClockwise, 
	CircleNotch 
}						from "@phosphor-icons/react";
import atlasApi			from "../utils/atlasapi";
import { timeAgo }		from "../utils/functions";

function ShowStatus({ status }) {

	useEffect(() => {

	}, [status]);



	if(!status.icon || !status.text)
		return;
		
		
	return (
		<div className={"show-status btn aep-3 mb-3 " + status.css}>
			<div className="row">
				<Col className="desc">
				{status.icon}{status.text}
				</Col>
				<Col className="timeleft">
					 {status.timeLeft}
				</Col>
			</div>
			<ProgressBar now={status.percent} />
			<div className="percent">{status.percent}%</div>
		</div>
	);
}

export default ShowStatus;
